<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div id="ag-grid-demo">
        <vx-card>
            <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <h4 style="margin-left: 10px">Service Types</h4>
                </div>
                <div
                    class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
                >
                    <vs-button
                        @click="refreshData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button
                        @click="showAddForm = true"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="add"
                    >Add</vs-button>
                    <vs-button
                        @click="viewData"
                        class="mb-4 md:mb-0 mr-1"
                        icon="remove_red_eye"
                        :disabled="selectedId ? false : true"
                    >View</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="removeData"
                        icon="delete"
                        :disabled="selectedId ? false : true"
                    >Delete</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="showFilterForm = true"
                        icon="filter_list"
                    >Filter</vs-button>
                    <vs-dropdown>
                        <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="getTemplate">Template</vs-dropdown-item>
                            <vs-dropdown-item @click="$refs.file.click()">Upload</vs-dropdown-item>
                            <input
                                type="file"
                                ref="file"
                                style="display: none"
                                v-on:change="uploadExcel"
                            />
                            <vs-dropdown-item
                                @click="exportExcel({ endpoint: 'master/servicetypes/report/exportexcel', name: 'servicetype', filter: filter })"
                            >Export</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="data"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="viewData"
            ></ag-grid-vue>
            <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>

            <vs-prompt @accept="filterData" title="Filter" :active.sync="showFilterForm">
                <div class="con-exemple-prompt">
                    <vs-input
                        placeholder="Service Type"
                        v-model="filter.service_type"
                        class="mt-4 mb-2 w-full"
                    />
                    <vs-input
                        placeholder="Description"
                        v-model="filter.description"
                        class="mt-4 mb-2 w-full"
                    />
                    <vs-input
                        placeholder="Transporter"
                        v-model="filter.transporter"
                        class="mt-4 mb-2 w-full"
                    />
                </div>
            </vs-prompt>

            <!-- Form view data -->
            <vs-prompt buttons-hidden title="View" :active.sync="showViewForm">
                <div class="con-exemple-prompt">
                    <vs-input
                        v-model="form.service_type"
                        class="mb-2 w-full"
                        label="Service Type"
                        :disabled="!editMode"
                    />
                    <vs-input
                        v-model="form.description"
                        class="mb-2 w-full"
                        label="Description"
                        :disabled="!editMode"
                    />
                    <vs-select
                        class="selectExample"
                        v-model="form.transporter"
                        width="100%"
                        autocomplete
                        label="Transporter"
                        :disabled="!editMode"
                    >
                        <vs-select-item v-for="(item, index) in transporter.data" :key="index" :value="item.id" :text="item.transporter_code"/>
                    </vs-select>
                    <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12">
                        <vs-button color="primary" class="mt-2 mr-2" @click="editMode = true">Edit</vs-button>
                        <vs-button
                            color="primary"
                            class="mt-2"
                            @click="saveData"
                            :disabled="!editMode"
                        >Save</vs-button>
                    </vs-row>
                </div>
            </vs-prompt>

            <!-- Form add data -->
            <vs-prompt buttons-hidden title="Add" :active.sync="showAddForm">
                <div class="con-exemple-prompt">
                    <vs-input v-model="form.service_type" class="mb-2 w-full" label="Service Type" />
                    <vs-input v-model="form.description" class="mb-2 w-full" label="Description" />
                    <vs-select
                        class="selectExample"
                        v-model="form.transporter"
                        width="100%"
                        autocomplete
                        label="Transporter"
                    >
                        <vs-select-item v-for="(item, index) in transporter.data" :key="index" :value="item.id" :text="item.transporter_code"/>
                    </vs-select>
                    <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12">
                        <vs-button color="primary" class="mt-2" @click="addData">Save</vs-button>
                    </vs-row>
                </div>
            </vs-prompt>
        </vx-card>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { saveAs } from "file-saver";
import vSelect from "vue-select";

export default {
    components: {
        vSelect,
        AgGridVue
    },
    data() {
        return {
            gridOptions: {},
            gridApi: null,
            data: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            selectedId: null,
            isLoading: false,
            editMode: false,
            filter: {
                service_type: "",
                description: "",
                transporter: "",
                strict_section: false
            },
            form: {
                service_type: "",
                description: "",
                transporter: null
            },
            transporter: {
                data: [],
                loading: false,
                endpoint: 'master/transporters',
                objectKey: 'transporter_code'

            },

            // Show forms
            showFilterForm: false,
            showViewForm: false,
            showAddForm: false,

            // Pagination
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function() {
            this.fetchData();
        }
    },
    methods: {
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsString = "";
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                    selectedRowsString += ", ";
                }
                selectedRowsString += selectedRow.id;
            });
            this.selectedId = selectedRowsString;
        },
        saveData() {
            this.isLoading = true;

            this.$http
                .put(
                    "master/servicetypes/" + this.selectedId + "/update",
                    this.form
                )
                .then(res => {
                    this.isLoading = false;
                    this.form = {
                        service_type: "",
                        description: ""
                    };
                    this.editMode = false;
                    this.showViewForm = false;
                    this.selectedId = null;
                    this.fetchData();
                })
                .catch(error => this.handleError(error));
        },
        addData() {
            this.err = "";
            this.isLoading = true;
            this.isLoading = true;
            this.$http
                .post("master/servicetypes/store", this.form)
                .then(res => {
                    this.showAddForm = false;
                    this.fetchData();
                })
                .catch(error => this.handleError(error))
                .then(() => (this.isLoading = false));
        },
        removeData() {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Confirm",
                text: "Are you sure want to delete this data?",
                accept: () => {
                    this.isLoading = true;
                    this.$http
                        .delete(
                            "master/servicetypes/" +
                                this.selectedId +
                                "/destroy"
                        )
                        .then(res => {
                            this.$vs.notify({
                                color: "success",
                                title: "Data deleted",
                                iconPack: "feather",
                                icon: "icon-check",
                                text:
                                    "The selected data was successfully deleted"
                            });
                            this.selectedId = null;
                            this.fetchData();
                        })
                        .catch(error => {
                            this.isLoading = false;
                            this.$vs.notify({
                                title: "Error",
                                text: "Something went wrong",
                                color: "danger"
                            });
                        });
                }
            });
        },
        refreshData() {
            this.currentPage == 1 ? this.fetchData() : (this.currentPage = 1);
        },
        fetchData() {
            this.isLoading = true;
            this.$http
                .post(
                    "master/servicetypes?page=" + this.currentPage,
                    this.filter
                )
                .then(resp => {
                    this.data = resp.data.data;
                    this.totalPage = resp.data.last_page;
                    this.currentPage = this.currentPage;
                    this.dataTotal = resp.data.total;
                    this.dataFrom = resp.data.from;
                    this.dataTo = resp.data.to;
                })
                .catch(() => {
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Error",
                        text: "Try again?",
                        accept: () => {
                            this.refreshData();
                        },
                        acceptText: "Yes",
                        cancelText: "No"
                    });
                })
                .then(() => (this.isLoading = false));
        },
        viewData() {
            this.isLoading = true;
            this.$http
                .get("master/servicetypes/" + this.selectedId)
                .then(res => {
                    this.editMode = false
                    this.form = res.data;
                    this.showViewForm = true;
                })
                .catch(error => console.log(error))
                .then(() => (this.isLoading = false));
        },
        filterData() {
            this.currentPage = 1;
            this.showFilterForm = false;
            this.fetchData();
        },
        getTemplate() {
            this.isLoading = true;
            this.$http
                .get("master/servicetypes/report/gettemplate", {
                    responseType: "blob"
                })
                .then(response => {
                    this.isLoading = false;
                    saveAs(response.data, "service-types-upload-template.xlsx");
                });
        },
        uploadExcel() {
            let file = event.target.files[0];
            let form = new FormData();
            form.append("file", file);
            this.isLoading = true;
            this.$http
                .post("/master/servicetypes/report/importexcel", form, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(resp => {
                    this.isLoading = false;
                    this.fetchData();
                    this.$vs.notify({
                        color: "success",
                        title: "Upload Success",
                        text: "Upload Data Service Types Successfully"
                    });
                })
                .catch(error => this.handleError(error))
                .then(() => (this.isLoading = false));
        },
        fetchTransporter() {
            this.isLoading = true
            Promise.all([
                this.$http.post('master/transporters'),
            ])
            .then(this.$http.spread((transporters) => {
                this.transporter.data = transporters.data.data
                this.isLoading = false
            }))
            .catch(error => this.handleError(error))
        },
    },
    mounted() {
        this.fetchData();
        this.fetchTransporter();
        this.gridApi = this.gridOptions.api;
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: "Service Type",
                field: "service_type",
                width: 120,
            },
            {
                headerName: "Description",
                field: "description",
                width: 120
            },
            {
                headerName: "Transporter",
                field: "transporter_name",
                width: 120
            }
        ];
        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>